import {useMemo} from "react";
import {Entity} from "../model/entity";
import {integrationHistoriesSelector} from "../store/entity/integration-history/selectors";
import {IntegrationHistory} from "../model/integration-history";
import {useGetIntegrationHistoryByObjectQuery} from "../store/entity/integration-history/integration-history-store";

export type UseGetEntityIntegrationHistoryProps = {
  entity: Entity,
}

export type UseGetEntityIntegrationHistoryResult = {
  history: IntegrationHistory[]
  isLoading?: boolean,
  isFetching?: boolean,
  refetch?: any
}

export const useGetEntityIntegrationHistory = (props: UseGetEntityIntegrationHistoryProps): UseGetEntityIntegrationHistoryResult => {
  const {
    entity,
  } = props;

  const selectIntegrationHistories = useMemo(() => {
    return integrationHistoriesSelector();
  }, []);

  const {history, isLoading, isFetching, refetch} = useGetIntegrationHistoryByObjectQuery({
    id: entity.id,
    type: entity.entityType,
  }, {
    selectFromResult: (result) => ({
      ...result,
      history: selectIntegrationHistories(result),
      isLoading: result.isLoading,
      isFetching: result.isFetching,
    })
  });

  return {
    history: history,
    isLoading: isLoading,
    isFetching: isFetching,
    refetch: refetch,
  };
};
